<template>
    <tbody>
        <tr v-for="item in list" :key="item.name" class="item">
            <td><img :src="item.img" />
            <td>{{ item.name }}</td>
            <td>${{ formatAmount(item.price) }}</td>
            <td class="text-center">{{ item.quantity }}</td>
            <td>${{ formatAmount(item.quantity * item.price) }}</td>
            <td class="text-center">${{ isCar ? 300 : formatAmount((1.015 * item.price)/18) }}</td>
        </tr>
    </tbody>
</template>

<script>
import { categories } from '../../../mixins/categories';

export default {
    props: {
        list: Array,
        isCar: Boolean,
    },
}
</script>

<style scoped>
.item img {
    height: 80px;
}
</style>